import { LoaderFunction } from 'react-router-dom';

// Constants
import { formActionNaming } from '../../../../../components/forms/ActionForms/constants';

// Utils
import { decompressSessionStorage } from '../../../../../utils/sessionStorage';

// GraphQL
import { client } from '../../../../../gql/client';
import {
  FETCH_ANIMALS,
  FETCH_ANIMAL_STATUS,
} from '../../../../../gql/queries/actions/animals';
import { claimDraftScope } from '../../../../../utils/draftOwnership';
import {
  ACTION_CREATION_SCOPE,
  ACTION_MEDIA_SCOPE,
  readCreationDraftId,
} from '../../../../../utils/draftScopes';
import { foreignCreationParentRedirect } from '../creationDraft';

export const AnimalsLoader: () => LoaderFunction | undefined =
  () => async ({ params, request }) => {
    // Un borrador de OTRO padre no se abre bajo esta URL: atrás, una URL
    // compartida o el «Editar» de un resumen viejo enseñaban — y guardaban — el
    // borrador de la OT Y bajo la de la X (auditoría de creación 2.3).
    const foreignParent = foreignCreationParentRedirect({ params, request });
    if (foreignParent) return foreignParent;
    // Las copias de las pestañas, la lista de fotos y el croquis son del
    // borrador en curso (`draftId`): si eran de otro, fuera, antes de que nadie
    // las lea. Síncrono y antes de cualquier `await`: el loader de `details` y el
    // de la pestaña corren en paralelo (spec 2026-11-02 wizard-draft-ownership).
    const draftId = readCreationDraftId();
    claimDraftScope(ACTION_CREATION_SCOPE, draftId);
    claimDraftScope(ACTION_MEDIA_SCOPE, draftId);

    // El trabajo entero vive aquí dentro, íntegro. Solo ha dejado de
    // esperarse: la promesa tiene que llegar PENDIENTE al `<Await>` para que
    // el router termine la navegación al instante y el `<Fallback>` enseñe el
    // Loader DENTRO de la pantalla nueva.
    const load = async () => {
    try {
    const stringifyForm = sessionStorage.getItem(
      formActionNaming.NEW_ANIMALS_FORM
    );
    const stringifyActionData = sessionStorage.getItem(
      formActionNaming.NEW_ACTION_DATA
    );
    let sessionStorageData;
    let breadCrumbsData;

    const {
      data: { animals: animalsUnsorted },
    } = await client.query({
      query: FETCH_ANIMALS,
    });

    const animals = [...animalsUnsorted].sort((a, b) =>
      a.animalId.localeCompare(b.animalId)
    );

    const {
      data: { animalAllStatus },
    } = await client.query({
      query: FETCH_ANIMAL_STATUS,
    });

    if (stringifyForm) {
      sessionStorageData = JSON.parse(decompressSessionStorage(stringifyForm));
    }

    if (stringifyActionData) {
      breadCrumbsData = JSON.parse(decompressSessionStorage(stringifyActionData));
    }

    const combinedData = {
      ...sessionStorageData,
      animals,
      animalAllStatus,
      breadCrumbsData: {
        orderParentId: breadCrumbsData?.orderParentId,
        orderParentRoid: breadCrumbsData?.orderParentRoid,
      },
    };

    return combinedData;
    } catch (err) {
      console.log('Loader offline fallback:', err);
      const stringifyActionData = sessionStorage.getItem(formActionNaming.NEW_ACTION_DATA);
      const breadCrumbsData = stringifyActionData ? JSON.parse(decompressSessionStorage(stringifyActionData)) : {};
      return { animals: [], animalAllStatus: [], breadCrumbsData: { orderParentId: breadCrumbsData?.orderParentId, orderParentRoid: breadCrumbsData?.orderParentRoid } };
    }
  };

    return { data: load() };
  };
